

const storeRuntime = {

    // namespaced: true,

    state: {
        // is the runtime state resored?
        runtimeStateRestored: false,
        // centerpoint viewport
        viewportCenter: [],
        // zoomfactor viewport
        viewportZoom: 0.0,
        // loaded theme names
        loadedThemeNames: [],
        // loaded feedback-theme names
        loadedFeedbackNames: [],
    },

    mutations: {
        RUNTIME_STATE_RESTORED(state, data) {
            // set the state restored flag
            state.runtimeStateRestored = data;
        },
        VIEWPORT_CENTER(state, data) {
            // set viewport center
            state.viewportCenter = data;
        },
        VIEWPORT_ZOOM(state, data) {
            // set viewport zoomfactor
            state.viewportZoom = data;
        },
        LOADED_THEME_NAMES(state, data) {
            // add theme name to loadedThemeNames list
            state.loadedThemeNames = Array.from(data);
        },
        LOADED_FEEDBACK_NAMES(state, data) {
            // add theme name to loadedFeedbackNames list
            state.loadedFeedbackNames = Array.from(data);
        },
    },

    actions: {
        runtimeStateRestored({ commit }, data) {
            commit('RUNTIME_STATE_RESTORED', data);
        },
        viewportCenter({ commit }, data) {
            commit('VIEWPORT_CENTER', data);
        },
        viewportZoom({ commit }, data) {
            commit('VIEWPORT_ZOOM', data);
        },
        loadedThemeNames({ commit }, data) {
            commit('LOADED_THEME_NAMES', data);
        },
        loadedFeedbackNames({ commit }, data) {
            commit('LOADED_FEEDBACK_NAMES', data);
        },
    },

    getters: {
        runtimeStateRestored: state => state.runtimeStateRestored,
        viewportCenter: state => state.viewportCenter,
        viewportZoom: state => state.viewportZoom,
        loadedThemeNames: state => state.loadedThemeNames,
        loadedFeedbackNames: state => state.loadedFeedbackNames,
    },

};

export default storeRuntime;
